<div class="app-sidebar-actions">
  <aad-language [isCollapsed]="isCollapsed()" />

  <ng-container *transloco="let t">
    <aml-action-button
      [icon]="IconNameMap.arrowRightFromBracket"
      [text]="t('navigation.logout')"
      [collapsed]="isCollapsed()"
      (buttonClicked)="logout()"
      customClass="logout-btn"
    />
  </ng-container>
</div>

<aad-logout-confirmation />
